export type SEmbedSection = "chat" | "dashboards" | "schedules";

export function sectionFromPath(path: string): SEmbedSection {
  const section = path.match(/^\/embed\/workspaces\/[^/]+\/apps\/[^/]+\/([^/?#]+)/)?.[1];
  return section === "dashboards" || section === "schedules" ? section : "chat";
}
